// ----------------------------------------------------------------------------
// OPTIONS
// ----------------------------------------------------------------------------
export const namespaced = true;

// ----------------------------------------------------------------------------
// STATE
// ----------------------------------------------------------------------------
export const state = {
  notifications: [],
};

let nextId = 1;

// ----------------------------------------------------------------------------
// MUTATIONS
// ----------------------------------------------------------------------------
export const mutations = {
  PUSH(state, notification) {
    state.notifications.push({
      ...notification,
      id: nextId++,
    });
    const idStatic = nextId-1;
    console.log("🚀  ~ idStatic", idStatic)
    setTimeout(() => {
      console.log("🚀  ~ eliminar notif", idStatic)
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== idStatic,
      );
    }, 3000);

  },
  DELETE(state, notificationToRemove) {
    state.notifications = state.notifications.filter(
      (notification) => notification.id !== notificationToRemove.id,
    );
  },
};

// ----------------------------------------------------------------------------
// ACTIONS
// ----------------------------------------------------------------------------
export const actions = {
  add({ commit }, notification) {
    commit('PUSH', notification);
  },
  addSuccess({ commit }, message) {
    commit('PUSH', { type: 'success', message });
  },
  addError({ commit }, message) {
    commit('PUSH', { type: 'error', message });
  },
  remove({ commit }, notificationToRemove) {
    commit('DELETE', notificationToRemove);
  },
};
